import ServicePageLayout from '../../components/feature/ServicePageLayout';

export default function FauxWoodBlindsPage() {
  return (
    <ServicePageLayout
      blindType="Faux Wood Blinds"
      heroImage="https://public.readdy.ai/ai/img_res/ae603a4d152b6a7707bf89c2b298c285.jpg"
      heroTitle="Faux Wood Blinds in Northampton"
      heroSubtitle="Stylish, durable and affordable faux wood venetian blinds professionally supplied and installed"
      introText="Looking for the perfect combination of style, durability and affordability? Our faux wood blinds offer the beautiful appearance of real wood at a fraction of the cost. Ideal for any room in your Northampton home, these moisture-resistant blinds are perfect for kitchens and bathrooms where real wood blinds may not be suitable. With a wide range of colours and finishes available, our faux wood venetian blinds provide excellent light control and privacy while adding a touch of elegance to your windows."
      features={[
        { icon: 'ri-water-flash-line', title: 'Moisture Resistant', desc: 'Perfect for kitchens and bathrooms where humidity is a concern. Unlike real wood, faux wood blinds won\'t warp or crack.' },
        { icon: 'ri-paint-brush-line', title: 'Wide Range of Finishes', desc: 'Choose from various wood-effect colours and finishes to match your interior décor perfectly.' },
        { icon: 'ri-shield-check-line', title: 'Extremely Durable', desc: 'Made from high-quality PVC or composite materials that are built to last for years without fading or damage.' },
        { icon: 'ri-hand-coin-line', title: 'Cost-Effective', desc: 'Get the luxurious look of real wood blinds at a much more affordable price point.' },
        { icon: 'ri-brush-line', title: 'Easy to Clean', desc: 'Simply wipe with a damp cloth to keep your blinds looking fresh and new.' },
        { icon: 'ri-sun-line', title: 'Excellent Light Control', desc: 'Adjustable slats allow you to control the amount of light entering your room with precision.' },
      ]}
      pricePerBlind="£109"
      wholeHousePrice="£849"
      benefits={[
        { icon: 'ri-check-line', text: 'Unbeatable prices' },
        { icon: 'ri-check-line', text: 'Professional installation' },
        { icon: 'ri-check-line', text: 'Moisture resistant' },
        { icon: 'ri-check-line', text: 'Easy maintenance' },
        { icon: 'ri-check-line', text: 'Wide colour range' },
      ]}
      faqs={[
        {
          question: 'What are faux wood blinds made from?',
          answer: 'Faux wood blinds are typically made from high-quality PVC, composite materials, or a combination of synthetic materials designed to replicate the appearance of real wood. These materials are specifically chosen for their durability, moisture resistance, and ability to maintain their appearance over time.'
        },
        {
          question: 'Can faux wood blinds be used in bathrooms and kitchens?',
          answer: 'Absolutely! One of the main advantages of faux wood blinds is their moisture resistance, making them ideal for high-humidity areas like bathrooms and kitchens. Unlike real wood, they won\'t warp, crack, or deteriorate when exposed to moisture and steam.'
        },
        {
          question: 'How do faux wood blinds compare to real wood blinds?',
          answer: 'Faux wood blinds offer several advantages: they\'re more affordable, moisture-resistant, easier to maintain, and more durable in humid conditions. While real wood blinds have a natural grain and warmth, modern faux wood blinds closely replicate this appearance at a fraction of the cost.'
        },
        {
          question: 'How do I clean faux wood blinds?',
          answer: 'Cleaning faux wood blinds is simple. Regular dusting with a soft cloth or duster is usually sufficient. For deeper cleaning, wipe the slats with a damp cloth and mild detergent, then dry with a clean cloth. The moisture-resistant properties make them much easier to clean than real wood.'
        },
        {
          question: 'What colours and finishes are available?',
          answer: 'We offer a wide range of colours and finishes including white, cream, grey, and various wood-effect tones from light oak to dark walnut. Our team can show you samples during your free consultation to help you choose the perfect match for your home.'
        },
        {
          question: 'How long does installation take?',
          answer: 'Installation is typically very quick. For most standard windows, our experienced installers can fit faux wood blinds in 15-30 minutes per window. A whole house installation can usually be completed in a single day.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  Perfect for Every Room
                </h3>
                <p className="text-gray-700 mb-6">
                  Faux wood blinds are incredibly versatile and suitable for any room in your Northampton home. Their moisture-resistant properties make them particularly ideal for:
                </p>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Kitchens</strong>
                      <p className="text-gray-600 text-sm">Resistant to cooking moisture and easy to wipe clean</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Bathrooms</strong>
                      <p className="text-gray-600 text-sm">Won't warp or crack in humid conditions</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Living Rooms</strong>
                      <p className="text-gray-600 text-sm">Elegant appearance that complements any décor</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#CC0000]/10 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#CC0000] text-sm"></i>
                    </div>
                    <div>
                      <strong className="text-gray-900">Bedrooms</strong>
                      <p className="text-gray-600 text-sm">Excellent light control for a good night's sleep</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=faux%20wood%20venetian%20blinds%20multiple%20windows%20bright%20modern%20kitchen%20white%20cabinets%20natural%20light%20wood%20effect%20slats%20clean%20contemporary%20British%20home%20interior%20no%20people%20professional%20photography%20neutral%20tones&width=800&height=600&seq=fauxwoodkitchen2025&orientation=landscape"
                  alt="Faux Wood Blinds in Kitchen"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
}